import './Objetivos.css';
import ObjetivosItem from '../ObjetivosItem'

const Objetivos = () =>  {
    return (
        <section className="objetivos">

                <h3 className='objetivos__titulo'>Pilares da Nossa Proposta</h3>
                <p className='objetivos__conteudo'>Acreditamos que o estudo sério e contínuo da Doutrina Espírita atua diretamente em áreas essenciais para o desenvolvimento integral do ser</p>

                <ul className="objetivos__lista">
                    <ObjetivosItem 
                        icon="self_improvement"
                        titulo="Espiritualidade: A Essência da Nossa Existência"
                        texto="Mais do que uma crença, a Espiritualidade é o reconhecimento da nossa natureza imortal e da nossa conexão com o Princípio Divino."
                        lista = {[
                            (<span><strong>Transcendência:</strong> Auxilia-nos a ir além da visão puramente material, compreendendo o sentido profundo da vida e a sua continuidade.</span>), 
                            (<span><strong>Fé Raciocinada:</strong> Estimula uma fé que caminha de mãos dadas com a razão, fundamentada na lógica e na experiência.</span>), 
                            (<span><strong>Busca pelo Divino:</strong> É o impulso inato que nos move em direção ao conhecimento de Deus e de Suas Leis. A compreensão desta área é vital para o nosso autoconhecimento e autoaperfeiçoamento.</span>)
                        ]}

                    />
                    <ObjetivosItem 
                        icon="mood"
                        titulo="Felicidade: O Destino da Alma"
                        texto="A busca pela Felicidade é o motor de todas as almas. O Espiritismo nos ensina que a Felicidade Plena é uma conquista que se alcança através do progresso moral e do cumprimento das Leis Divinas."
                        lista = {[
                            (<span><strong>Propósito de Vida:</strong> Através dos estudos, buscaremos entender nossos propósitos reencarnatórios, que são a bússola para a nossa evolução.</span>), 
                            (<span><strong>Aprimoramento Íntimo:</strong> A verdadeira alegria reside na paz de consciência e na prática do bem. Abordaremos como a reforma íntima é o caminho seguro para alcançar a felicidade inabalável.</span>)
                        ]}

                    />

                    <ObjetivosItem 
                        icon="scale"
                        titulo="Equilíbrio: A Harmonia do Ser"
                        texto="Ao estudar a espiritualidade buscaremos entender como ela poderá nos auxiliar na busca pelo equilíbrio de nossa vida. Equilibrar nossas emoções, o nosso corpo, saúde mental e física na busca de uma vida plena."                    
                        lista = {[
                            (<span><strong>Saúde Integral:</strong> Buscaremos entender como as Leis Morais e o autoconhecimento influenciam a saúde mental e física.</span>),
                            (<span><strong>Gestão das Emoções:</strong> Aprenderemos a harmonizar nossas emoções, superando vícios morais e cultivando virtudes para viver em um estado de serenidade e plenitude.</span>)
                        ]}
                    /> 
                </ul>
            </section>

    );

}

export default Objetivos;